import $ from "jquery";
import _ from "underscore";
import AppBase from "../core/base/App";
import BaseLayout from "./views/layouts/Base";
import messenger from "./Messenger";
import NavigationOperations from "../core/operations/NavigationOperations";
import * as ReactDOM from "react-dom";
import ActionDispatcher from "../core/operations/ActionDispatcher";

var left = [];
var right = [];
var leftRegistrations = [];
var rightRegistrations = [];

var App = AppBase.extend({
  /**
   * Gets the default layout name for this application.
   * @protected
   * @return {string} The layout name.
   */
  getDefaultLayout: function () {
    return "NoMenu";
  },

  /**
   * Disables scrolling in the main scroll container.
   */
  disableScroll: function () {
    $("body > .scroll-container").css("overflow-y", "hidden");
    this.canScroll = false;
  },

  /**
   * Enabled scrolling in the main scroll container.
   */
  enableScroll: function () {
    $("body > .scroll-container").css("overflow-y", "");
    this.canScroll = true;
  },

  /**
   * Hide the action icons, or those controls created by `registerItemAction` or `registerNavigationAction`.
   */
  hideActions: function () {
    $(".actions").hide();
  },

  /**
   * Shows the action icons, or those controls created by `registerItemAction` or `registerNavigationAction`.
   */
  showActions: function () {
    $(".actions").show();
  },

  /**
   * Clears the action icons.
   */
  clearActions: function () {
    _.each(leftRegistrations, function (registrationId) {
      ActionDispatcher.unregister(registrationId);
    });
    _.each(rightRegistrations, function (registrationId) {
      ActionDispatcher.unregister(registrationId);
    });

    leftRegistrations = [];
    rightRegistrations = [];
    left = [];
    right = [];
  },

  /**
   * Begins changing the overall page layout.
   * @param {string} name    The name of the new layout. This can be one of `'NoMenu'`, `'Wide'`, or `'WithMenu'`. The associated layout views are located in `public/js/app/views/layouts`.
   * @return {Promise} A promise object which resolves when the layout is finally changed.
   */
  setLayout: function (name) {
    var baseEl = document.getElementById("app-content");
    var self = this;
    var deferred = new $.Deferred();
    var props = {
      layoutName: name,
      left: left,
      right: right,
      app: this,
      view: this.view,
    };

    if (baseEl) {
      ReactDOM.unmountComponentAtNode(baseEl);
    }

    var baseLayout = new BaseLayout(props);

    ReactDOM.render(baseLayout.render(), baseEl, function () {
      self.layout = baseLayout;
      deferred.resolve(self.layout);
    });
    return deferred.promise();
  },

  resetLayout: function () {
    var layout = this.layout;
    var layoutName = "NoMenu";

    if (layout) {
      layoutName = layout.name;
    }

    return this.setLayout(layoutName);
  },

  /**
   * Creates an icon in the navigation area (upper-left) and attaches an operation to it. If the icon is clicked, the operation is invoked with this app, the current router, and a null model.
   * @param {string | Operation} operationId The identifier of the NavigationOperation to attach to the icon. If all three arguments are given, this is the (tooltip) text for the navigation operation. If this is an object, it is interpreted as an `Operation`.
   * @param {string} [text] The text to display for the icon tooltip. If all three arguments are given, this argument is used to specify the icon. Available icons can be found at http://getbootstrap.com/components/#glyphicons. To use the "plus" icon, the value of this argument should be `"plus"`.
   * @param {string} [relativeUrl] If all three arguments are given, this will be the path sent to `navigate` for the navigation operation.
   * @param {mixed} [model] The model with which to invoke the operation. The default is `{trigger: true}`.
   * @return {ActionView}        The ActionView that was created, or null, if the operation isn't available.
   */
  registerNavigationAction: function (operationId, text, relativeUrl, model) {
    var operation;

    if (_.isString(relativeUrl)) {
      operation = NavigationOperations.createNavigationOperation(
        operationId,
        text,
        relativeUrl
      );
      text = "";
    } else if (_.isString(operationId)) {
      operation = NavigationOperations.get(operationId);
    } else {
      operation = operationId;
    }

    model = model || {
      trigger: true,
    };

    var options = {
      icon: operation.get("icon"),
      tooltipText: text || operation.get("text"),
      tooltipPosition: "right",
      itemKey: function () {
        return options.tooltipText || options.icon;
      },
    };

    var actionView = null;

    if (operation.available(model)) {
      leftRegistrations.push(
        ActionDispatcher.register(function (action) {
          if (action.icon == options.icon) {
            operation
              .action(model)
              .done(function (model, message) {
                if (_.isString(message)) {
                  messenger.success(message);
                }
              })
              .fail(function (message) {
                if (_.isString(message)) {
                  messenger.error(message);
                }
              });
          }
        })
      );

      left.push(options);
      this.resetLayout();
    }

    return actionView;
  },

  /**
   * Creates an icon in the item area (upper-right) and attaches an operation to it.
   * @param  {Operation} operation   The operation to attach to the control.
   * @param  [model] The model with which to invoke the operation.
   * @return {app/views/ActionView}        The ActionView that was created, or null, if the operation is not available.
   */
  registerItemAction: function (operation, model) {
    var options = {
      icon: operation.get("icon"),
      tooltipText: operation.get("text"),
      tooltipPosition: "left",
      itemKey: function () {
        return options.tooltipText || options.icon;
      },
    };

    var actionView = null;

    if (operation.available(model)) {
      rightRegistrations.push(
        ActionDispatcher.register(function (action) {
          if (action.icon == options.icon) {
            operation
              .action(model)
              .done(function (model, message) {
                if (_.isString(message)) {
                  messenger.success(message);
                }
              })
              .fail(function (message) {
                if (_.isString(message)) {
                  messenger.error(message);
                }
              });
          }
        })
      );

      right.push(options);
      this.resetLayout();
    }

    return actionView;
  },
});

export default new App();



//////////////////
// WEBPACK FOOTER
// ./public/js/app/App.js
// module id = 47
// module chunks = 1